import { getComponent } from '../utils'
import { h } from 'vue'
import { prefix } from '../prefix'
import Layout from '@/layouts/main-layout.vue'
import { RoleGuard } from '../guards'
import { ExperimentOutlined, SlidersOutlined } from '@ant-design/icons-vue'
import type { RouteRecordRaw } from 'vue-router'

export const org_admin_routes: RouteRecordRaw[] = [
  {
    path: '/lab',
    name: 'lab',
    component: () => getComponent(`pages/lab.vue`),
    meta: {
      title: () => 'Lab',
      layout: Layout,
      is_public: false,
      guard: RoleGuard(['org_admin', 'super_admin']),
      menu: {
        separate: true,
        key: 'Lab',
        label: 'Lab',
        icon: () => h(ExperimentOutlined),
        path: `${prefix}/lab`,
      },
    },
  },
]
